
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wgs/select",
      function () {
        return require("private-next-pages/wgs/select.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wgs/select"])
      });
    }
  